import { IconComponentsProps } from './types';

const CatalogIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.5 1.5C19.8978 1.5 20.2792 1.65815 20.5605 1.93945C20.8419 2.22076 21 2.60218 21 3V21C21 21.3978 20.8419 21.7792 20.5605 22.0605C20.2792 22.3419 19.8978 22.5 19.5 22.5H6C5.60218 22.5 5.22076 22.3419 4.93945 22.0605C4.65815 21.7792 4.5 21.3978 4.5 21V18H3V16.5H4.5V12.75H3V11.25H4.5V7.5H3V6H4.5V3C4.5 2.60218 4.65815 2.22076 4.93945 1.93945C5.22076 1.65815 5.60218 1.5 6 1.5H19.5ZM6 6H7.5V7.5H6V11.25H7.5V12.75H6V16.5H7.5V18H6V21H19.5V3H6V6ZM16.5 16.5V18H10.5V16.5H16.5ZM16.5 12.75H10.5V11.25H16.5V12.75ZM16.5 7.5H10.5V6H16.5V7.5Z"
      fill={fill}
    />
  </svg>
);

export default CatalogIcon;
